import { useEffect, useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AdminPageHeader } from "@/components/admin/AdminBits";
import { RichTextEditor } from "@/components/RichTextEditor";

export default function AdminAbout() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/public/settings").then((r) => { setContent(r.data.about?.content || ""); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/about", { content }); toast.success("About page updated"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Save failed"); }
    setSaving(false);
  };

  return (
    <div data-testid="admin-about-page">
      <AdminPageHeader title="About page" subtitle="Edit the public About page content."
        action={<button onClick={save} disabled={saving || loading} data-testid="about-save-button" className="inline-flex items-center gap-2 rounded-full bg-ukf-red px-5 py-2.5 text-sm font-semibold text-white transition-all hover:bg-ukf-red-dark active:scale-[0.98] disabled:opacity-60">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save</button>} />
      {loading ? <p className="text-sm text-slate-400">Loading…</p> : (
        <div className="max-w-3xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <RichTextEditor value={content} onChange={setContent} placeholder="Write official information about UKF…" />
        </div>
      )}
    </div>
  );
}
